export enum RouteNames {
  AgentDetails = 'AgentDetails',
  AgentMonitoring = 'AgentMonitoring',
  AgentOverview = 'AgentOverview',
  PlatformConnections = 'PlatformConnections',
  Topology = 'Topology',
}
